import type { Ref } from 'react';
import { forwardRef } from 'react';

import type { TIconSize } from '../icon.interface';

const RecycleIcon = forwardRef(
  ({ ...props }: TIconSize, ref: Ref<SVGSVGElement>) => {
    return (
      <svg
        preserveAspectRatio="none"
        viewBox="-1 -3 24 24"
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.779 8.552C19.329 3.945 15.065.557 10.25.985A8.99 8.99 0 0 0 5.929 2.54C3.93 3.748 3.053 5.59 3.053 5.59S3.99 4.028 6.68 3.14c2.765-.914 7.405.87 8.364 5.412H13.55l3.864 3.337 3.859-3.337h-1.493Z"
          fill="#82D7FC"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.377 7.798c-.101 2.68 1.168 7.3 5.037 8.535 3.742 1.195 6.283-.548 7.691-2.075.438-.581.645-1.013.645-1.013s-.938 1.562-3.626 2.45c-2.767.913-7.406-.87-8.365-5.412h1.495L5.377 7.798Z"
          fill="#D6DFE5"
        />
        <mask
          id="a"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="2"
          y="0"
          width="20"
          height="13"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.51.43h19.304v11.978H2.51V.43Z"
            fill="white"
          />
        </mask>
        <g mask="url(#a)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.726 8.61h1.39l-3.702 3.201-3.707-3.201h1.413l-.015-.07c-.79-3.735-4.063-5.69-6.888-5.69-.56 0-1.084.08-1.556.236-1.632.54-2.63 1.335-3.163 1.877.434-.642 1.24-1.634 2.468-2.375a8.93 8.93 0 0 1 4.292-1.545 8.896 8.896 0 0 1 6.645 2.122c1.615 1.4 2.615 3.315 2.817 5.393l.006.052Zm1.545-.576h-1.012c-.667-4.39-4.493-7.576-9.13-7.603h-.12a9.546 9.546 0 0 0-5.383 1.68C3.529 3.383 2.597 5.294 2.559 5.375a.508.508 0 0 0 .245.677.566.566 0 0 0 .248.057.55.55 0 0 0 .47-.26c.008-.014.907-1.417 3.334-2.219a4.332 4.332 0 0 1 1.359-.203c2.28 0 5.16 1.442 6.136 4.607h-.803a.545.545 0 0 0-.506.332c-.08.2-.022.429.143.571l3.864 3.337a.555.555 0 0 0 .727 0l3.843-3.324a.507.507 0 0 0 .195-.398.531.531 0 0 0-.543-.518Z"
            fill="#1A1A1A"
          />
        </g>
        <mask
          id="b"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="6"
          width="20"
          height="13"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 6.483h19.304V18.46H0V6.483Z"
            fill="white"
          />
        </mask>
        <g mask="url(#b)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.09 10.282H.7l3.702-3.2 3.707 3.2H6.696l.015.07c.789 3.735 4.062 5.69 6.888 5.69.56 0 1.083-.08 1.556-.236 1.632-.539 2.63-1.334 3.163-1.877-.434.642-1.24 1.634-2.468 2.376a8.93 8.93 0 0 1-4.292 1.544 9.23 9.23 0 0 1-.813.037 8.896 8.896 0 0 1-5.832-2.158c-1.615-1.4-2.615-3.316-2.817-5.394l-.006-.052Zm-1.547.575h1.012c.666 4.39 4.493 7.576 9.13 7.603h.12a9.547 9.547 0 0 0 5.383-1.68c2.096-1.272 3.028-3.183 3.067-3.264a.508.508 0 0 0-.245-.677.566.566 0 0 0-.248-.057.55.55 0 0 0-.47.26c-.008.014-.907 1.417-3.334 2.219a4.33 4.33 0 0 1-1.36.203c-2.28 0-5.16-1.442-6.136-4.607h.804a.545.545 0 0 0 .505-.332.506.506 0 0 0-.142-.571L4.765 6.617a.555.555 0 0 0-.727 0L.195 9.942A.508.508 0 0 0 0 10.34a.53.53 0 0 0 .543.518Z"
            fill="#1A1A1A"
          />
        </g>
      </svg>
    );
  }
);
export default RecycleIcon;
